/*LIBRARY*/
import React, { useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

/*COMPONENT*/
import Modal from "../common_modal/Modal";
import FLOAT_MENU from "../common_trivial/FLOAT_MENU";

/*REDUX*/
import { createProjectNew } from "../../App/actions/layerNewActions";
import { post_activities } from "../../App/actions/activities";

/*PICTURE*/
import checklist from "../../Assets/svg/checklist.svg";

/*FUNCTION*/
import isEmpty from "../../App/validation/is-empty";
import formatDate from "../../App/validation/format-date";

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

const CREATE_PROJECT = ({
  auth,
  project,
  layer,
  createProjectNew,
  toggle_create_project,
  post_activities,
}) => {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [isPublic] = useState(false);
  const [isPersonal, setIsPersonal] = useState(true);
  const [modalGroup, setModalGroup] = useState(false);
  const [modalLicense, setModalLicense] = useState(false);
  const [modalWarningNotAdmin, setModalWarningNotAdmin] = useState(false);
  const [group, setGroupState] = useState({});
  const [anchorCollab, setAnchorCollab] = useState(null);
  const [modalCollabMenu, setModalCollabMenu] = useState(false);

  const { user, domain, groups } = auth;
  const {
    folder_object_selected_list,
    folder_id_selected,
    folder_object_selected,
  } = project;
  const { loading_status, loading_item } = layer;

  const toggleWarningNotAdmin = () => {
    setModalWarningNotAdmin(!modalWarningNotAdmin);
  };

  const toggleLicense = () => {
    setModalLicense(!modalLicense);
  };

  const setPersonal = () => {
    setIsPersonal(true);
  };

  const toggleGroup = () => {
    setModalGroup(!modalGroup);
  };

  const setGroup = (selectedGroup) => {
    setGroupState(selectedGroup);
    setIsPersonal(false);
    setTimeout(() => {
      setModalGroup(false);
    }, 500);
  };

  const toggleCollabMenu = (event) => {
    setModalCollabMenu(!modalCollabMenu);
    setAnchorCollab(event?.currentTarget || null);
  };

  const handleSetPersonal = () => {
    setPersonal();
    setModalCollabMenu(false);
  };

  const handleSetCollaboration = () => {
    toggleGroup();
    setModalCollabMenu(false);
  };

  const handleChange = (e) => {
    e.preventDefault();
    const { name: inputName, value } = e.target;
    if (inputName === "name") {
      setName(value);
    } else if (inputName === "description") {
      setDescription(value);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const isOrg = !isPersonal && !isEmpty(group);
    const group_id = isOrg ? group._id : "";
    const user_id = isOrg ? group.creator_id : user._id;

    const key =
      folder_object_selected_list && folder_object_selected_list.length > 0
        ? "geo_project_list_child"
        : "geo_project_list";

    const body = {
      key,
      date: Date.now(),
      name,
      description,
      user_id,
      isPublic,
      group_id,
      domain,
      folder_id_selected,
    };
    createProjectNew(body);
    toggle_create_project();
    post_activities({
      action: "create_project",
    });
  };

  //local storage
  const language = localStorage?.language || auth.language;

  //content
  const isOrg = !isPersonal && !isEmpty(group);

  let button_content;

  if (loading_status && loading_item === "create_project") {
    button_content = (
      <div className="button_big background_grey">
        {dict["Processing..."][language]}
      </div>
    );
  } else {
    button_content = (
      <button
        type="submit"
        className="button_big background_black"
        data-mapid="clickCreateProject"
      >
        {dict["Create Project"][language]}
      </button>
    );
  }

  const modal_collab_content = (
    <FLOAT_MENU
      anchorEl={anchorCollab}
      open={modalCollabMenu}
      onClose={toggleCollabMenu}
    >
      <main style={{ width: "167px" }}>
        <section
          className={`container full_width margin_bottom ${
            !isOrg ? "background_black" : "button_white"
          }`}
          onClick={handleSetPersonal}
          style={{ cursor: "pointer", padding: "10px", textAlign: "center" }}
        >
          <p className="text_medium">Personal</p>
        </section>
        <section
          className={`container full_width ${
            isOrg ? "background_black" : "button_white"
          }`}
          onClick={handleSetCollaboration}
          style={{ cursor: "pointer", padding: "10px", textAlign: "center" }}
        >
          <p className="text_medium">{dict?.["Collaboration"]?.[language]}</p>
        </section>
      </main>
    </FLOAT_MENU>
  );

  const content = (
    <div>
      {folder_object_selected?._id && (
        <section className="container_light background_grey_light margin_bottom">
          <p>
            {dict?.["In a folder"]?.[language]}: <br /> <br />
            <b className="text_medium">{folder_object_selected?.name}</b>
          </p>
        </section>
      )}
      <form onSubmit={handleSubmit} className="margin_top">
        <p className="text_bold margin_bottom">
          {dict["Project name"][language]}
        </p>
        <input
          type="text"
          name="name"
          id="name"
          placeholder={dict["Project name"][language]}
          value={name}
          onChange={handleChange}
          className="margin_bottom_extra"
          data-mapid="insertProjectName"
        />

        <p className="text_bold margin_bottom">
          {dict["Project description"][language]}
        </p>
        <textarea
          name="description"
          className="margin_bottom_extra"
          id="description"
          placeholder={dict["Project description"][language]}
          value={description}
          onChange={handleChange}
          rows="4"
          data-mapid="insertProjectDeskription"
        />
        <section
          className="two_container_equal margin_bottom"
          style={{ display: "flex", alignItems: "center", gap: "16px" }}
        >
          <p
            className="text_bold"
            style={{ whiteSpace: "nowrap", flexShrink: 0, margin: 0 }}
          >
            Collaboration option
          </p>
          <button
            type="button"
            className="button background_grey_light full_width"
            onClick={toggleCollabMenu}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span>
              {!isOrg ? "Personal" : dict?.["Collaboration"]?.[language]}
            </span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#000"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="table_body_svg_icon"
            >
              <path d="M6 9l6 6 6-6" />
            </svg>
          </button>
        </section>
        <br />
        <br />
        <br />
        {button_content}
      </form>
    </div>
  );

  const modalGroupContent = modalGroup && (
    <Modal
      modalSize="medium"
      id="modal"
      isOpen={modalGroup}
      onClose={toggleGroup}
    >
      <div
        className="box-body"
        style={{ minHeight: "80vh", textAlign: "center" }}
      >
        <div style={{ textAlign: "center" }}>
          {dict["Choose your group or team"][language]}{" "}
        </div>
        {groups.map((group_element) => {
          const { name: groupName, _id, members, payment } = group_element;
          let organizationContent = null;
          if (!isEmpty(payment)) {
            const { date_in } = payment;
            const multiple_month = payment.multiple_month
              ? payment.multiple_month
              : 1;
            //86400 unix = 1 day
            //1 month = 30.5 day
            const month_unix = 86400 * 30.5;
            const day_unix = 86400;
            const date_finish_unix =
              parseInt((new Date(date_in).getTime() / 1000).toFixed(0), 10) +
              month_unix * multiple_month;
            const date_now_unix = parseInt(
              (new Date(Date.now()).getTime() / 1000).toFixed(0),
              10,
            );
            const delta_unix =
              (date_finish_unix - date_now_unix) * multiple_month;
            const delta_day = parseInt(delta_unix / day_unix, 10);
            const date_finish = new Date(date_finish_unix * 1000);
            if (delta_day > 0) {
              if (delta_day > 30) {
                organizationContent = (
                  <div className="badge_normal" id="grey_light">
                    <b>
                      {dict["Team license active until"][language]}{" "}
                      {formatDate(date_finish)}
                    </b>
                  </div>
                );
              } else {
                organizationContent = (
                  <div className="badge_normal" id="grey_light">
                    <b>
                      {dict["Team license active for"][language]}
                      {delta_day}
                      {dict["days"][language]}
                    </b>
                  </div>
                );
              }
            } else {
              organizationContent = (
                <div className="badge_normal" id="grey_light">
                  <b>{dict["Team license exp."][language]}</b>
                </div>
              );
            }
          }
          let userStatus = "viewer";
          const array_member_filtered = members.filter(
            (member) => member?.user?._id === user._id,
          )[0];
          userStatus = array_member_filtered?.status;
          let checkContent;
          if (_id === group._id) {
            checkContent = <img alt="checklist" src={checklist} width="11px" />;
          }
          let group_button_content = (
            <main
              className="container_basic"
              style={{
                display: "inline-block",
                margin: "10px",
                width: "150px",
                minHeight: "120px",
                fontSize: "12px",
                cursor: "pointer",
                overflow: "hidden",
                backgroundColor: "#d3d3d3",
                color: "#fff",
                borderRadius: "10px",
                position: "relative",
                verticalAlign: "top",
              }}
              onClick={toggleWarningNotAdmin}
              key={_id}
            >
              <section
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  maxHeight: "60px",
                  width: "95px",
                  overflow: "hidden",
                  fontWeight: "bold",
                }}
              >
                <div style={{ overflow: "hidden", maxHeight: "45px" }}>
                  {groupName}
                </div>
              </section>
              {organizationContent}
            </main>
          );
          if (userStatus === "creator" || userStatus === "admin") {
            group_button_content = (
              <main
                className="container_basic"
                style={{
                  display: "inline-block",
                  margin: "10px",
                  width: "150px",
                  minHeight: "120px",
                  fontSize: "12px",
                  cursor: "pointer",
                  overflow: "hidden",
                  backgroundColor: "#0ca5eb",
                  color: "#fff",
                  borderRadius: "10px",
                  position: "relative",
                  verticalAlign: "top",
                }}
                onClick={() => setGroup(group_element)}
                key={_id}
              >
                <section
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    maxHeight: "60px",
                    width: "95px",
                    overflow: "hidden",
                    fontWeight: "bold",
                  }}
                >
                  <div style={{ overflow: "hidden", maxHeight: "45px" }}>
                    {groupName}
                  </div>{" "}
                  {checkContent}
                </section>
                {organizationContent}
              </main>
            );
          }
          return group_button_content;
        })}
      </div>
    </Modal>
  );

  const modalLicenseContent = modalLicense && (
    <Modal
      modalSize="small"
      id="modal"
      isOpen={modalLicense}
      onClose={toggleLicense}
    >
      <div className="box-body">
        <main
          style={{
            marginTop: "100px",
            marginBottom: "100px",
            textAlign: "center",
          }}
        >
          <section className="text_medium" style={{ marginBottom: "20px" }}>
            {
              dict[
                "You do not own your license or your license has expired, please renew your license."
              ][language]
            }
          </section>
          <Link to="/user_profile" className="button_block background_black">
            {dict["Renew License"][language]}
          </Link>
        </main>
      </div>
    </Modal>
  );

  const modalWarningNotAdminContent = modalWarningNotAdmin && (
    <Modal
      modalSize="small"
      id="warning modal"
      isOpen={modalWarningNotAdmin}
      onClose={toggleWarningNotAdmin}
    >
      <div className="box-body" style={{ textAlign: "center" }}>
        <main className="text_bold">
          {
            dict[
              "You are only viewer in this group, only admin can add group to the project."
            ][language]
          }
        </main>
      </div>
    </Modal>
  );

  return (
    <main>
      {modal_collab_content}
      {content}
      {modalGroupContent}
      {modalLicenseContent}
      {modalWarningNotAdminContent}
    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  project: state.project,
  layer: state.layer,
});

export default connect(mapStateToProps, { createProjectNew, post_activities })(
  CREATE_PROJECT,
);
